import s from './Users.scss'
import { If } from 'components/ideal-core-ui'
import cn from 'classnames'

const Users = ({ users }) => {
  const visibleUsers = users.slice(0, 3)
  const hiddenUsers = users.slice(3)
  return (
    <div>
      <If condition={hiddenUsers.length}>
        <div className={cn(s.user, s.pullRight, s.more)}>{hiddenUsers.length}</div>
      </If>
      <If condition={visibleUsers.length}>
        <div className={s.userWrapper}>
          {visibleUsers.map(user => (
            <div
              title={user.userName}
              key={user.userId}
              className={cn(s.user, s.pullRight)}
              style={{ backgroundImage: `url(${user.userImage || '/images/no_picture.png'})` }}
            />
          ))}
        </div>
      </If>
    </div>
  )
}

export default Users
